import axios from "axios";
import { store } from "./../reducers";

export const BASE_PATH = process.env.REACT_APP_API_URL;
export const BASE_V2_PATH = process.env.REACT_APP_API_V2_URL;

axios.interceptors.response.use(
  function (response) {
    if (response.data.responseCode === 5) {
      store.dispatch({ type: "TOGGLE_AUTH_TOKEN_MODAL" });
      return Promise.reject(response.data);
    }
    return response;
  },
  function (error) {}
);

export const getInvest = (authToken) =>
  axios({
    url: `${BASE_V2_PATH}/invest`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const forwardEmail = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/forwardEmail`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const saveResume = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/saveResume`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const getEfinancialResumeDownload = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/efinancialResumeDownload/`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const getEfinancialResumeViewById = (authToken, id) =>
  axios({
    url: `${BASE_PATH}/efinancialResumeView/${id}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const getSavedJobById = (authToken, id) =>
  axios({
    url: `${BASE_PATH}/savedJob/${id}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const createCustomJob = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/createCustomJob`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const updateSavedJob = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/savedJob`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const deleteSavedJob = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/savedJob`,
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const saveJob = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/saveJob`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const getSavedJobs = (authToken) =>
  axios({
    url: `${BASE_PATH}/getSavedJobs`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const getJobSearchReminders = (authToken) =>
  axios({
    url: `${BASE_PATH}/getJobSearchReminders`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const getJobStats = (authToken) =>
  axios({
    url: `${BASE_PATH}/getJobStats`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const getNewJobs = (authToken) =>
  axios({
    url: `${BASE_PATH}/newJobs`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const getTalentSearchs = (authToken) =>
  axios({
    url: `${BASE_PATH}/talentSearchs`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const getTalentSearchReminders = (authToken) =>
  axios({
    url: `${BASE_PATH}/talentSearchReminders`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const addOffer = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/offer`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const getOffers = (authToken) =>
  axios({
    url: `${BASE_PATH}/offers`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const deleteReminder = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/reminder`,
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const createReminder = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/reminder`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const setReminderWithEvent = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/reminderWithEvent`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const createInvoice = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/invoice`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const getReport = (authToken, start, end, type) =>
  axios({
    url: `${BASE_PATH}/report?start=${start}&end=${end}&type=${type}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const getInvoices = (authToken) =>
  axios({
    url: `${BASE_PATH}/invoices`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const getInvoice = (authToken, id) =>
  axios({
    url: `${BASE_PATH}/invoice?id=${id}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const editInvoice = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/invoice`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const generateCV = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/generateCV`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const uploadFile = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/uploadFile`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const login = (payload) =>
  axios({
    url: `${BASE_V2_PATH}/login`,
    method: "post",
    headers: { "Content-Type": "application/json" },
    data: payload,
  });

export const getMyaccount = (authToken) =>
  axios({
    url: `${BASE_PATH}/myaccount`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const editMyaccount = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/myaccount`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const updatePassword = (authToken, payload) =>
  axios({
    url: `${BASE_V2_PATH}/password`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const getClients = (authToken) =>
  axios({
    url: `${BASE_PATH}/clients`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const getClient = (authToken, id) =>
  axios({
    url: `${BASE_PATH}/client?id=${id}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const createClient = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/client`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const editClient = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/client`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const editClientNotes = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/clientNotes`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const createContact = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/contact`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const getContacts = (authToken) =>
  axios({
    url: `${BASE_PATH}/contacts`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const getContact = (authToken, id) =>
  axios({
    url: `${BASE_PATH}/contact?id=${id}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const findContactsByName = (authToken, firstname, lastname) =>
  axios({
    url: `${BASE_PATH}/findContactsByName?firstname=${firstname}&lastname=${lastname}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const editContact = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/contact`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const editContactNotes = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/contactNotes`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const getCandidates = (authToken) =>
  axios({
    url: `${BASE_PATH}/candidates`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const getCandidate = (authToken, id) =>
  axios({
    url: `${BASE_PATH}/candidate?id=${id}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const findCandidatesByName = (authToken, firstname, lastname) =>
  axios({
    url: `${BASE_PATH}/findCandidatesByName?firstname=${firstname}&lastname=${lastname}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const createCandidate = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/candidate`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const editCandidate = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/candidate`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const editCandidateNotes = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/candidateNotes`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const getVacancyById = (authToken, id) =>
  axios({
    url: `${BASE_PATH}/vacancy/${id}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const getVacancies = (authToken) =>
  axios({
    url: `${BASE_PATH}/vacancies/`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const getEvents = (authToken, days) =>
  axios({
    url: `${BASE_PATH}/events/${days}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const newEvent = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/event`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const deleteEvent = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/event`,
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const readEvent = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/event`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const getDashboard = (authToken) =>
  axios({
    url: `${BASE_PATH}/dashboard`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const getEmails = (authToken, box, nextPageToken) =>
  axios({
    url:
      nextPageToken === ""
        ? `${BASE_PATH}/emails/${box}`
        : `${BASE_PATH}/emails/${box}?nextToken=${nextPageToken}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const copyEmail = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/email`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const getDrive = (authToken, folderID) =>
  axios({
    url: `${BASE_PATH}/drive?driveFolder=${folderID}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const uploadDrive = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/drive`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const updateDriveFile = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/drive`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const preAdvancedSearch = (authToken) =>
  axios({
    url: `${BASE_PATH}/presearch`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const advancedSearch = (authToken, type, payload) =>
  axios({
    url: `${BASE_PATH}/search/${type}`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const emailShot = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/emailshot`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const getErrorEmails = (authToken) =>
  axios({
    url: `${BASE_PATH}/erroremails`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const getBlackList = (authToken) =>
  axios({
    url: `${BASE_PATH}/blacklist`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });

export const createBlacklistEntry = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/blacklistentry`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const actionEvent = (authToken, payload) =>
  axios({
    url: `${BASE_PATH}/actionEvent`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: payload,
  });

export const getTransactions = (authToken) =>
  axios({
    url: `${BASE_V2_PATH}/transactions`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });
